import dialogType from '../../../../../../../display/dialogs/dialogType'
import Method     from '../../../../../../../net/Method'

const factors =
{
    edit  :
    {
        agree       : 'Enregistrer' ,
        description : 'Sélectionner des facteurs de risque dans la liste ci-dessous.',
        disagree    : 'Annuler' ,
        fail        : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading     : 'Chargement en cours...',
        method      : Method.PATCH,
        mock        : false ,
        refresh     : 'Charger',
        success     : 'Mise à jour réussie!' ,
        title       : 'Facteurs de risques' ,
        type        : dialogType.THESAURUS_CHECKER
    },
    title : 'Liste des facteurs de risques' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Modifier" ,
        remove : "Supprimer"
    }
};

export default factors ;